/**
 * B495 - the `Suspense` fallback of the lazy Settings route.
 *
 * The first cold visit to Settings (the chunk is fetched on the first tap) waited about a second on a bare
 * "Loading settings…" line in the top left corner: the fallback in `App.tsx` was a `<div role="status">` holding
 * text, with none of the page's look. Races and Team met the same defect and `RouteFrame` is their answer
 * (`components/RouteFrame/RouteFrame.tsx`): the page's own cream at the page's own height, the same status role, the
 * same words as its accessible name and none on screen.
 *
 * With `settings_2_0_v1` on (the surface whose page is that cream) the fallback is the frame. With it off it is the
 * original element, byte for byte. Nothing is drawn in the frame: no bar, no chrome, no words, so neither the phone
 * layout nor the desktop shell is hinted at and neither is replaced when the route lands.
 *
 * Wiring: `App.tsx`, the `/settings` route, `fallback={<SettingsRouteFallback />}` in place of
 * `fallback={<div role="status">Loading settings…</div>}`.
 */
import { useServerFlag } from '../../hooks/useServerFlag';
import { RouteFrame } from '../RouteFrame/RouteFrame';

export function SettingsRouteFallback() {
  const settings2 = useServerFlag('settings_2_0_v1');
  if (settings2) return <RouteFrame label="Loading settings" />;
  return <div role="status">Loading settings…</div>;
}
